import React, { FC } from 'react';

import { ContentFragment, UserFeedFollowGroupFragment } from 'api';
import { ContentProvider } from 'providers';

import { getLayout } from 'features/content/helpers';

interface Props {
  content: ContentFragment;
  selectedGroup?: UserFeedFollowGroupFragment;
}

const FeedListItem: FC<Props> = props => {
  const { content, selectedGroup } = props;
  const ContentComponent = getLayout(content);

  function renderGroupFeedItem() {
    return <ContentComponent selectedGroup={selectedGroup} />;
  }

  function renderUserFeedItem() {
    return <ContentComponent />;
  }

  return (
    <ContentProvider value={content}>
      {selectedGroup ? renderGroupFeedItem() : renderUserFeedItem()}
    </ContentProvider>
  );
};

export default FeedListItem;
